export const routes = {
  home: "/",
  privacyPolicy: "/privacy-policy",
  terms: "/terms"
}
